export default class BaseCaptchaService {
  load = () => Promise.resolve();

  // returns the captcha token: Promise<String>
  execute = () => undefined;

  shouldRetry = () => false;

  refresh = () => undefined;

  destroy = () => undefined;
}
